export default [
  {
    name: 'trQuery',
    path: '/tr/trQuery',
    component: resolve => require(['Views/Tr/trQuery'], resolve),
    meta: {
      include: ['TrQuery'],
      index: 1
    }
  },
  {
    name: 'trList',
    path: '/tr/trList',
    component: resolve => require(['Views/Tr/trQuery/trList'], resolve),
    meta: {
      include: ['TrList', 'TrQuery', 'TripAdd', 'TripRoute'],
      index: 2
    }
  },
  {
    name: 'trDetail',
    path: '/tr/trDetail',
    component: resolve => require(['Views/Tr/trQuery/trDetail'], resolve),
    meta: {
      include: ['TrDetail', 'TrQuery', 'TrList', 'TripAdd', 'TripRoute'],
      index: 3
    }
  },
  {
    name: 'trEdit',
    path: '/tr/trEdit',
    component: resolve => require(['Views/Tr/trQuery/trEdit'], resolve),
    meta: {
      include: ['TrEdit', 'TrQuery', 'TrList', 'TrDetail'],
      index: 4
    }
  },
  {
    name: 'trCmp',
    path: '/tr/trCmp/:id',
    component: resolve => require(['Views/Tr/trOrder/Cmp'], resolve),
    props: true,
    meta: {
      include: [],
      index: 5
    }
  },
  {
    name: 'trOrderDetail',
    path: '/tr/OrderDetail/:id',
    component: resolve => require(['Views/Tr/trOrder/Detail'], resolve),
    props: true,
    meta: {
      include: [],
      index: 6
    }
  },
  {
    name: 'trApplyAlter',
    path: '/tr/ApplyAlter/:id',
    component: resolve => require(['Views/Tr/trChange/ApplyAlter'], resolve),
    props: true,
    meta: {
      include: ['TrApplyAlter', 'TrDetail'],
      index: 7
    }
  },
  {
    name: 'trAlterCmp',
    path: '/tr/AlterCmp/:id',
    component: resolve => require(['Views/Tr/trChange/AlterCmp'], resolve),
    props: true,
    meta: {
      include: [],
      index: 5
    }
  },
  {
    name: 'trChangeDetail',
    path: '/tr/ChangeDetail/:id',
    component: resolve => require(['Views/Tr/trChange/ChangeDetail'], resolve),
    props: true,
    meta: {
      include: [],
      index: 8
    }
  },
  {
    name: 'trApplyRefund',
    path: '/tr/ApplyRefund',
    component: resolve => require(['Views/Tr/trRefund/ApplyRefund'], resolve),
    meta: {
      include: [],
      index: 7
    }
  },
  {
    name: 'trRefundCmp',
    path: '/tr/RefundCmp/:id',
    component: resolve => require(['Views/Tr/trRefund/RefundCmp'], resolve),
    props: true,
    meta: {
      include: [],
      index: 5
    }
  },
  {
    name: 'trRefundDetail',
    path: '/tr/RefundDetail/:id',
    component: resolve => require(['Views/Tr/trRefund/RefundDetail'], resolve),
    props: true,
    meta: {
      include: [],
      index: 8
    }
  },
  {
    name: 'OrderService',
    path: '/tr/OrderService',
    component: resolve => require(['Views/Tr/trOrder/OrderService'], resolve),
    props: true,
    meta: {
      include: ['TrEdit'],
      index: 6
    }
  }
]
